import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function fetchBuyerCards () {
    try {
      const { data } = await axios.get('/card')
      if (data.cards.length) {
        return data.cards.map(card => Mapper.card(card, false))
      } else {
        return []
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function addBuyerCard (card) {
    try {
      const { data } = await axios.post('/card', card)
      if (data.card) {
        return Mapper.card(data.card, true)
      } else {
        return { message: data.message }
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function addBuyerAccount (tokenId) {
    try {
      const { data } = await axios.post('/add-bank', {token: tokenId})
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function fetchBuyerACH () {
    try {
      const { data } = await axios.get('/bank-account')
      if (data.bank_accounts.length) {
        return data.bank_accounts.map(ach => Mapper.ach(ach))
      } else {
        return []
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function deleteBuyerCard (id) {
    try {
      const { data } = await axios.delete(`/card/${id}`)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function deleteBuyerAchAccount (id) {
    try {
      const { data } = await axios.delete(`/bank-account/${id}`)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function verifyBuyerAchAccount (formData) {
    try {
      const { data } = await axios.post('/verify-bank-account', formData)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function createCheckoutSummary (formData) {
    try {
      const { data } = await axios.post('/checkout/summary', formData)
      return Mapper.summary(data.order_summary)
    } catch (error) {
      return { error: error.message }
    }
  }

  return {
    fetchBuyerCards,
    addBuyerCard,
    deleteBuyerCard,
    fetchBuyerACH,
    addBuyerAccount,
    deleteBuyerAchAccount,
    verifyBuyerAchAccount,
    createCheckoutSummary
  }
}

export default Requests()